export const BUCKET_TYPE = {
    TopLevel: 'TOP_LEVEL',
    InvestmentType: 'INVESTMENT_TYPE',
    Wrapper: 'WRAPPER',
};
export const BUCKET_TYPES = [
    BUCKET_TYPE.TopLevel,
    BUCKET_TYPE.InvestmentType,
    BUCKET_TYPE.Wrapper,
];
